<template>
<div class="background-enabled">

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <!-- PROFESSIONALS -->
    <nav
        class="panel"
    >
        <div
            v-for="(professional, index) in professionals"
            :key="index"
            class="panel-block"
        >
            <span class="panel-icon">
                <b-icon
                    pack="fas"
                    :icon="professional.type === 1 ? 'user-shield' : 'user'"
                />
            </span>
            <span class="professional-details">
                <span class="professional-name">
                    {{ professional.username }}
                    <template v-if="professional.alias">
                        ({{ professional.alias }})
                    </template>
                </span>
                <span class="professional-email">{{ professional.email }}</span>
            </span>
            <span
                v-if="config.login !== 'ad'"
                class="panel-icon panel-icon-right panel-icon-red"
                @click="deleteProfessional(professional.username)"
            >
                <b-icon
                    pack="fas"
                    icon="trash"
                />
            </span>
        </div>
    </nav>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button v-show="config.login !== 'ad'" class="button is-info actions-btn" @click="createProfessional()">
            <b-icon
                pack="fas"
                icon="plus">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'ListProfessionals',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            professionals: [],
            isLoading: true,
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
        this.listProfessionals();
    },
    methods: {
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        back() {
            this.$router.push('/professional/call');
        },
        createProfessional() {
            this.$router.push('/admin/create');
        },
        listProfessionals() {
            HealthCareService.getProfessionals()
                .then(res => {
                    this.setLoading(false);
                    this.professionals = res.data;
                })
                .catch(error => {
                    this.setLoading(false);
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        deleteProfessional(username) {
            this.$buefy.dialog.confirm({
                message: this.texts.deleteProfessionalConfirmation,
                cancelText: this.texts.no,
                confirmText: this.texts.yes,
                type: 'is-success',
                onConfirm: () => {
                    HealthCareService.deleteProfessional(username)
                        .then(res => {
                            this.listProfessionals();
                        })
                        .catch(error => {
                            const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                            this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                        })
                },
            });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.professional-details {
    text-align: left;
    max-width: 65%;
    overflow: hidden;
    .professional-name {}
    .professional-email {
        margin-top: -5px;
        font-size: .7em;
        display: block;
    }
}
.panel {
    max-height: calc(100vh - 110px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 10px 10px;
    .panel-icon {
        background: #167df0;
        height: 40px;
        width: 40px;
        color: white;
        border-radius: 20px;
        font-size: 14px;
        padding-top: 8px;
        cursor: pointer;
    }
    .panel-icon-gray {
        cursor: not-allowed;
    }
    .panel-icon-right {
        margin-left: auto;
        margin-right: 0;
    }
    .panel-icon-right ~ .panel-icon-right {
        margin-left: 10px;
        order: 2;
        margin-right: 0;
    }
    .panel-icon-red {
        background: #ff3860;
    }
    .panel-icon-gray {
        background: #888;
    }
    .panel-block {
        background: #eee;
        margin-bottom: 3px;
        font-size: 1.2em;
    }
    .panel-block-disabled {
        .panel-icon {
            cursor: not-allowed;
            background: #888;
        }
    }
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ListProfessionals.vue